import React from 'react';

interface IProps {
  className?: string;
}

export function NotFound({ className }: IProps) {
  return (
    <svg
      className={className}
      id="prefix__b48d11bd-edef-44e5-b622-00da69e86340"
      xmlns="http://www.w3.org/2000/svg"
      x={0}
      y={0}
      viewBox="0 0 92 97"
      xmlSpace="preserve"
    >
      <style>{'.prefix__st2{fill:none;stroke:#163e63;stroke-width:2}'}</style>
      <g opacity={0.6}>
        <g id="prefix__a1c82103-fa64-46ba-bde6-c3ec1fb128cc">
          <g id="prefix__e4120f49-a5fe-4129-9ffa-1b4100a16ba9">
            <g id="prefix__ef97e4aa-5ee2-4fa0-a682-304d39904d32">
              <path
                id="prefix__b285ac04-46ff-4e34-9540-3f4fe0b3e745"
                fill="none"
                stroke="#163e63"
                strokeWidth={2}
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M69 73.7L91 96"
              />
              <ellipse
                id="prefix__bf3baf16-4f85-4f16-9778-c6c36311a228"
                className="prefix__st2"
                cx={41.5}
                cy={42.4}
                rx={40.5}
                ry={41.4}
              />
            </g>
          </g>
        </g>
        <path
          className="prefix__st2"
          d="M34.7 28.3s14.1-4.5 15.6 3c1.7 8.2-13.5 9.4-10.5 21.2"
        />
        <circle cx={40.9} cy={59.2} r={1.8} fill="#163e63" />
      </g>
    </svg>
  );
}
